import type {PageRouteConfig} from '@router';

import OrderStatus from 'modules/Orders/OrderStatus/OrderStatus';
import {routes} from 'routes/routes';

export function createOrderStatusRoute(): PageRouteConfig {
  return {
    element: <OrderStatus />,
    layout: {
      title: 'جزئیات سفارش',
      hasNavigate: false,
      hasHeader: true,
      hasBack: true,
      hasLeftIcon: false,
      resolveLink: (ctx) => {
        const from = new URLSearchParams(ctx.location?.search).get('from');

        return from ? -1 : routes.ORDERS;
      }
    }
  };
}
